export const escapeCsvCell = (value) => {
    if (value == null) {
        return '';
    }
    const str = String(value);
    if (/[",\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
};
export const toCsvRow = (values) => values.map(escapeCsvCell).join(',');
export const formatMemberExportCustomFields = (fields) => {
    if (!(fields === null || fields === void 0 ? void 0 : fields.length)) {
        return '';
    }
    return JSON.stringify(fields.map(({ name, value }) => ({ name, value })));
};
